class Page
{
    constructor()
    {
    }

    static isDesktop(): boolean
    {
        return window.innerWidth >= 1140;
    }

    static isTablet(): boolean
    {
        return window.innerWidth < 1120;
    }

    static isPhablet(): boolean
    {
        return window.innerWidth < 992;
    }

    static isPhone(): boolean
    {
        return window.innerWidth < 660;
    }

    static orientation(element: HTMLElement): "portrait" | "landscape"
    {
        element = element ? element : document.querySelector(".l-Base");

        return (element.offsetWidth <= element.offsetHeight) ? "portrait" : "landscape";
    }

    //https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js
    static isTouchDevice(): boolean
    {
        let prefixes: string[] = ' -webkit- -moz- -o- -ms- '.split(' ');

        let touchsupport: boolean = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

        if (touchsupport)
            return true;

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        let query: string = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return window.matchMedia(query).matches;
    }

    static getHeaderHeight(): number | null
    {
        let header: HTMLElement = document.querySelector(".m-HeaderPrimary");
        return header ? header.getBoundingClientRect().height : null;
    }

    static scrollTo(top: number, left: number = 0): void
    {
        top = top ?? 0;
        left = left ?? 0;
        window.scrollTo({top: top, left: left, behavior: "smooth"});
    }

    static scrollToTop(): void
    {
        this.scrollTo(0);
    }

    static setUrl(newUrl: string, pushToHistory: boolean = false): boolean
    {
        if (!newUrl || typeof newUrl !== "string")
            return false;

        if (pushToHistory)
        {
            window.history.pushState({path: newUrl}, "", newUrl);
        }
        else
        {
            window.history.replaceState({path: newUrl}, "", newUrl);
        }

        return true;
    }


    static getCurrentUrl(): string
    {
        return window.location.href;
    }

    static getUrlParameter(parameterName: string, urlString: string | null = null): string | null
    {
        urlString = urlString ?? window.location.href;

        let url: URL = new URL(urlString);

        return url.searchParams.get(parameterName);
    }

    static removeUrlParameter(parameterName: string, urlString: string | null = null): string
    {
        urlString = urlString ?? window.location.href;

        let url: URL = new URL(urlString);
        let urlParams: URLSearchParams = url.searchParams;

        urlParams.delete(parameterName);
        url.search = urlParams.toString();

        return url.toString();
    }

    static setUrlParameter(parameterName: string, parameterValue: string, urlString: string | null = null): string
    {
        urlString = urlString ?? window.location.href;

        let url: URL = new URL(urlString);
        let urlParams: URLSearchParams = url.searchParams;

        urlParams.set(parameterName, parameterValue);
        url.search = urlParams.toString();

        return url.toString();
    }

    /*
        let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?param=' + value;
        window.history.replaceState({ path: newUrl }, '', newUrl);
     */

}

export {Page};
